import { API_BASE } from "./utils";

/**
 * Resolve the best logo URL for a connector.
 *
 * Priority: explicit icon > domain favicon proxy > undefined.
 *
 * The favicon is served through our own API (`/api/v1/favicon?domain=...`)
 * rather than hitting Google directly. This avoids leaking which connectors
 * each customer uses to Google on every page load and keeps the logos
 * available when Google is blocked or rate-limited.
 */
export function connectorLogoUrl(icon?: string, domain?: string): string | undefined {
  if (icon) return icon;
  if (!domain) return undefined;
  const hostname = domain.replace(/^https?:\/\//, "").replace(/\/.*$/, "");
  if (!hostname) return hostname || undefined;
  return `${API_BASE}/v1/favicon?domain=${encodeURIComponent(hostname)}&sz=128`;
}
